/**
 * @fileoverview Omni-bar TextField mode for TaskInputQuick.
 */
import { Box, TextField, IconButton, InputAdornment } from '@mui/material';
import AddCircle from '@mui/icons-material/AddCircle';
import PlaylistAddCircle from '@mui/icons-material/PlaylistAddCircle';
import { TaskInputTokenPreview } from '@/features/tasks/components/forms/TaskInputTokenPreview';

const FOCUSED_OUTLINE_SX = {
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'secondary.main',
  },
};

const TaskInputQuickOmni = ({
  className,
  sx,
  inputId,
  fieldPlaceholder,
  inputValue,
  errorMessage,
  onInputFocus,
  onInputBlur,
  handleOmniChange,
  handleQuickAddKeyDown,
  disableEmptyNavigate,
  handleQuickAddButtonClick,
  trailingActionLabel,
  showTokenPreview,
  parsedPreview,
}) => (
  <Box className={className} sx={{ width: '100%', ...(sx || {}) }}>
    <TextField
      id={inputId}
      sx={FOCUSED_OUTLINE_SX}
      fullWidth
      variant="outlined"
      size="small"
      placeholder={fieldPlaceholder}
      value={inputValue}
      onFocus={onInputFocus}
      onBlur={onInputBlur}
      onChange={handleOmniChange}
      onKeyDown={handleQuickAddKeyDown}
      error={!!errorMessage}
      helperText={errorMessage || null}
      InputProps={
        disableEmptyNavigate
          ? undefined
          : {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleQuickAddButtonClick}
                    edge="end"
                    className="cta-pill cta-pill--ghost"
                    aria-label={trailingActionLabel}
                    title={trailingActionLabel}
                    size="small"
                  >
                    {inputValue.trim() ? (
                      <AddCircle fontSize="small" />
                    ) : (
                      <PlaylistAddCircle fontSize="small" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }
      }
    />
    {showTokenPreview ? (
      <TaskInputTokenPreview parsed={parsedPreview} dense />
    ) : null}
  </Box>
);

export default TaskInputQuickOmni;
